import React, { Component, useState } from 'react';
import { Modal, Button } from 'antd';
import {
  CloseOutlined
} from '@ant-design/icons';
import '../assets/scss/Rule.scss';

const RulePanel = (props) => {
  return (
    <>
      <div className='rule-wrap'>
        <Button 
          className='rule-closeBtn'
          type='text'
          shape="circle" 
          icon={<CloseOutlined className='closeBtn-icon' />} 
          onClick={props.closeMethod}
        />
        <div className='rule-header'>
          <div className='header-title'>抽奖规则</div>
        </div>
        <div className='rule-paragraph'>
          <div className='rule-title'>一、抽奖次数获取方式</div>
          <div className='rule-content'>1.连续7个自然日登录APP，不可中断。第七日获取一次抽奖次数，进度条清空重计。</div>
          <div className='rule-content'>2.单日订单实付金额满3000元（不含税）及以上，可获取一次抽奖次数。退款金额不计入订单金额。</div>
          <div className='rule-content'>3.邀请新用户注册并填写您的推广码，可获取一次抽奖次数。推广码可在“账户设置”内查看。</div>
        </div>
        <div className='rule-paragraph'>
          <div className='rule-title'>二、开奖方式</div>
          <div className='rule-content'>抽奖结果将通过APP内弹窗即时通知。</div>
        </div>
        <div className='rule-paragraph'>
          <div className='rule-title'>三、奖品兑奖须知</div>
          <div className='rule-content'>1.中奖奖品均以优惠券形式自动发放，注意优惠券使用有效期。卡券过期不予补发。</div>
          <div className='rule-content'>2.实物奖品需联系客服并通过拍下指定链接填写收货信息。奖品随货物订单或由快递方式发放。</div>
          <div className='rule-content'>3.优惠券类奖品需满足优惠券使用条件。</div>
        </div>
        <div className='rule-paragraph'>
          <div className='rule-title'>四、其他</div>
          <div className='rule-content'>1.单品赠送使用优惠券后金额0.01元为获取收件信息。</div>
          <div className='rule-content'>2.本次抽奖由温州莱泽气动科技有限公司举办，与其他第三方平台无关。</div>
        </div>
        <div className='rule-sign'>所有解释权归温州莱泽气动科技有限公司所有</div>
      </div>
    </>
  )
} 

const Rule = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <span className='rule-button' onClick={showModal}>点击查看抽奖规则</span>
      <Modal 
        width={'90vw'} 
        open={isModalOpen} 
        footer={null} 
        maskClosable={true} 
        onCancel={handleCancel} 
        modalRender={
          () => (
            <RulePanel closeMethod={handleCancel} />
          )
        }
      />
    </>
  );
}

export default Rule;